import { getRandomUuidV4, MimeTypeService, HttpContentType, PDF_THUMBNAIL, updateJpegImageFileNameExtension, getRenamedFile, getFileNameExtension } from "../../common";
import { FileUploadError, FileUploadStatus, SupportedFileType } from '../enums';
import { FileValidationService } from './FileValidationService';
import { ImageScalingService } from './ImageScalingService';
import { FileHelperService } from './FileHelperService';
export class FileService {
    static uploadFiles(uploadFilesPayload) {
        const { maxFileCount, onFileUploadStartFailure, fileList, onAllFileUploadComplete, onFilesReady, maxParallelUploadCount, maxUploadUsageInBytes, maxVideoFileSize } = uploadFilesPayload;
        if (maxFileCount && fileList.length > maxFileCount) {
            if (onFileUploadStartFailure) {
                onFileUploadStartFailure(FileUploadError.MAX_FILE_COUNT_EXCEEDED);
            }
            return;
        }
        if (maxUploadUsageInBytes) {
            let toBeUploadingSize = 0;
            for (const file of Array.from(fileList)) {
                toBeUploadingSize = toBeUploadingSize + file.size;
            }
            if (toBeUploadingSize > maxUploadUsageInBytes) {
                if (onFileUploadStartFailure) {
                    onFileUploadStartFailure(FileUploadError.MAX_ALLOTTED_STORAGE_USED);
                }
                return;
            }
        }
        const files = this.getFileInfos(uploadFilesPayload);
        const uploadFilesActionPayload = {
            files,
            onAllFileUploadComplete,
            maxParallelUploadCount,
            maxVideoFileSize
        };
        onFilesReady(uploadFilesActionPayload);
    }
    static getFileInfos(uploadFilesPayload) {
        const { fileList, applicationName, companyCode, thumbnailMaxSize } = uploadFilesPayload;
        const isPdfTaggingEnabled = uploadFilesPayload.isPdfTaggingEnabled || false;
        let fileInfos = Array.from(fileList).map(file => {
            return this.getFileInfo(uploadFilesPayload, file, applicationName, companyCode);
        });
        if (thumbnailMaxSize) {
            fileInfos = this.getFileInfosWithThumbnails(fileInfos, thumbnailMaxSize, isPdfTaggingEnabled);
        }
        return fileInfos;
    }
    static getFileInfo(uploadFilesPayload, file, applicationName, companyCode) {
        const uploadError = FileValidationService.validateFile(Object.assign(Object.assign({}, uploadFilesPayload), { file }));
        const fileExtension = getFileNameExtension(file.name);
        if (fileExtension.toUpperCase() === SupportedFileType.JPEG &&
            uploadFilesPayload.isJPEGImageExtensionRenameEnabled) {
            const newJpegImageFileName = updateJpegImageFileNameExtension(file.name);
            // since file.name is readonly, need to replace input file with new File object that has new file.name
            file = getRenamedFile(file, newJpegImageFileName);
        }
        return {
            uploadStatus: uploadError ? FileUploadStatus.FAILED : FileUploadStatus.READY,
            file,
            id: getRandomUuidV4(),
            fileName: file.name.replace(/[^a-zA-Z0-9\-\._]/g, ''),
            fileSizeInBytes: file.size,
            originalFileSizeInBytes: file.size,
            applicationName,
            companyCode,
            uploadError,
            maxImageSize: ImageScalingService.isImageScalable(file.name) ? uploadFilesPayload.scaledMaxSize : undefined,
            maxVideoFileSize: FileValidationService.isVideoFileType(file.name)
                ? uploadFilesPayload.maxVideoFileSize
                : undefined,
            isDuplicateDocumentAllowed: uploadFilesPayload.isDuplicateDocumentAllowed,
            maximumAllowedImageWidth: uploadFilesPayload.maximumAllowedImageWidth,
            maximumAllowedImageHeight: uploadFilesPayload.maximumAllowedImageHeight,
            fileDescription: uploadFilesPayload.fileDescription
        };
    }
    static getFileInfosWithThumbnails(fileInfos, maxImageSize, isPdfTaggingEnabled) {
        const fileInfosWithThumbnails = [];
        for (let index = 0; index < fileInfos.length; index++) {
            fileInfosWithThumbnails.push(fileInfos[index]);
            const extensionIndex = fileInfos[index].fileName.lastIndexOf('.');
            const filename = fileInfos[index].fileName.substring(0, extensionIndex);
            const mimeType = MimeTypeService.lookup(fileInfos[index].fileName);
            if (mimeType === HttpContentType.APPLICATION_PDF && isPdfTaggingEnabled) {
                fileInfosWithThumbnails.push(Object.assign(Object.assign({}, fileInfos[index]), { fileName: `${filename} ${PDF_THUMBNAIL}`, id: getRandomUuidV4(), maxImageSize: maxImageSize, parentId: fileInfos[index].id }));
            }
            else if (fileInfos[index].uploadStatus === FileUploadStatus.READY &&
                ImageScalingService.isImageScalable(fileInfos[index].fileName)) {
                // add thumbnails for files
                const thumbnailFileInfo = FileHelperService.mapToThumbnailFileInfo(fileInfos[index], fileInfos[index].file, fileInfos[index].uploadStatus, maxImageSize);
                fileInfosWithThumbnails.push(thumbnailFileInfo);
            }
        }
        return fileInfosWithThumbnails;
    }
}
//# sourceMappingURL=FileService.js.map